import { Flex, Select, Space, Steps } from "antd"
import { BaseContainer, BaseSegmented } from "components/containers"
import { FillButton } from "components/elements"
import { StepDotWrapper } from "components/styled/wrapper"
import { monthOptions, yearOptions } from "data/options"
import { fnGetToday } from "utils/utils"

const OrderStepContainer = ({ step, type, yyyy, mm, setYyyy, setMm, fnImport, fnAuto, fnInit, fnMoniteringModal }) => {
  const typeOptions = [
    { label: '신규회원주문', value: 1 },
    { label: '기존회원주문', value: 0 },
  ]

  const stepItems = [
    { title: 'STEP 1', description: '주문하기' },
    { title: 'STEP 2', description: '주문 모니터링 확인' },
    { title: 'STEP 3', description: '주문 수정하기' },
    { title: 'STEP 4', description: '결제하기' },
    { title: 'STEP 5', description: '주문 완료' }
  ]
  
  return (
    <BaseContainer>
      <Flex vertical gap={'30px'}>
        <Flex justify={'center'}>
          <BaseSegmented
            disabled 
            value={type}
            options={typeOptions}
          />
        </Flex>

        <StepDotWrapper>
          <Steps
            progressDot
            current={step}
            items={stepItems}
          />
        </StepDotWrapper>

        {step !== 1 && step !== 4 &&
          <Flex justify={'end'}>
            <Space size={5}>
              {step === 3 
                ?
                  <>
                    <span style={{ fontSize: '18px' }}>학습기간</span>
                    <span style={{ fontSize: '18px' }}>{fnGetToday('yyyymm')}</span>
                  </>
                :
                  <>
                    학습기간
                    <Select
                      value={yyyy}
                      style={{ width: '10rem' }}
                      options={yearOptions('2025', 0, false)}
                      onSelect={(v) => setYyyy(v)}
                    />
                    <Select
                      value={mm}
                      style={{ width: '8rem' }}
                      options={monthOptions}
                      onSelect={(v) => setMm(v)}
                    />
                  </>
              }

              <Space size={3}>
                {step === 0 && 
                  <>
                    <FillButton label={'불러오기'} backgroundColor={'var(--color-gray03)'} onClick={fnImport} />
                    <FillButton label={'전체자동(필수)'} backgroundColor={'var(--color-gray03)'} onClick={() => fnAuto(1)} />
                    {/* <FillButton label={'전체자동(필수+추가)'} backgroundColor={'var(--color-gray03)'} onClick={() => fnAuto(0)} /> */}
                    <FillButton label={'초기화'} backgroundColor={'var(--color-red04'} onClick={fnInit} />
                  </>
                }
                {step === 2 && 
                  <>
                    <FillButton label={'초기주문내역으로 돌아가기'} backgroundColor={'var(--color-red04'} onClick={fnInit} />
                    <FillButton label={'모니터링 다시보기'} backgroundColor={'var(--color-gray03)'} onClick={fnMoniteringModal} />
                  </>
                }
              </Space>
            </Space>
          </Flex>
        }
      </Flex>
      </BaseContainer>
  )
}

export default OrderStepContainer